(function () {
  function initFaqSearch(root) {
    var input = root.querySelector('[data-flip-faq-search]');
    var empty = root.querySelector('[data-flip-faq-empty]');
    var nav = root.querySelector('.flip-faq-page__nav');
    var categories = Array.prototype.slice.call(root.querySelectorAll('[data-flip-faq-category]'));

    if (!input || !categories.length) return;

    input.addEventListener('input', function () {
      var query = input.value.trim().toLowerCase();
      var visibleQuestions = 0;

      categories.forEach(function (category) {
        var questions = Array.prototype.slice.call(category.querySelectorAll('details'));
        var categoryMatches = 0;

        questions.forEach(function (question) {
          var matches = !query || question.textContent.toLowerCase().indexOf(query) !== -1;
          question.hidden = !matches;
          if (matches) {
            categoryMatches += 1;
            visibleQuestions += 1;
            if (query.length >= 3) question.open = true;
          } else {
            question.open = false;
          }
        });

        category.hidden = categoryMatches === 0;

        if (nav && category.id) {
          var navLink = nav.querySelector('a[href="#' + category.id + '"]');
          if (navLink) navLink.hidden = category.hidden;
        }
      });

      if (empty) {
        empty.hidden = visibleQuestions !== 0;
        empty.classList.toggle('is-visible', visibleQuestions === 0);
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-flip-faq-page]'),
      initFaqSearch
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
